import { render, staticRenderFns } from "./space1.vue?vue&type=template&id=25f9c57e&scoped=true"
import script from "./space1.vue?vue&type=script&lang=js"
export * from "./space1.vue?vue&type=script&lang=js"
import style0 from "./space1.vue?vue&type=style&index=0&id=25f9c57e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f9c57e",
  null
  
)

export default component.exports